import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "row", "editLink" ]

  declare rowTargets: HTMLElement[]
  declare editLinkTargets: HTMLAnchorElement[]

  private selectedIndex = -1
  private handler = (e: KeyboardEvent): void => this.handleKeydown(e)

  connect(): void {
    window.addEventListener("keydown", this.handler)
  }

  disconnect(): void {
    window.removeEventListener("keydown", this.handler)
  }

  private handleKeydown(e: KeyboardEvent): void {
    const target = e.target as HTMLElement | null
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT")) return
    if (e.metaKey || e.ctrlKey || e.altKey) return

    const visibleRows = this.rowTargets.filter((r) => !r.hidden)
    if (visibleRows.length === 0) return

    if (e.key === "j") {
      e.preventDefault()
      this.selectedIndex = Math.min(this.selectedIndex + 1, visibleRows.length - 1)
      this.highlight(visibleRows)
    } else if (e.key === "k") {
      e.preventDefault()
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
      this.highlight(visibleRows)
    } else if (e.key === "Enter" && this.selectedIndex >= 0) {
      e.preventDefault()
      const row = visibleRows[this.selectedIndex]
      const link = row?.querySelector<HTMLAnchorElement>("a.link")
      link?.click()
    }
  }

  private highlight(rows: HTMLElement[]): void {
    rows.forEach((r, i) => {
      r.classList.toggle("bg-base-300", i === this.selectedIndex)
    })
    rows[this.selectedIndex]?.scrollIntoView({ block: "nearest" })
  }
}
